var n = "_container_167hq_1",
  o = "_iconWrapper_167hq_9",
  r = {
    container: n,
    iconWrapper: o
  };
export { n as container, r as default, o as iconWrapper };